export default class ClubExamPart {

    constructor() {
        this.id = null;
        this.clubExamId = null;
        this.description = '';
        this.archived = false;
        this.isDeletable = true;
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        let clubExamPart = new ClubExamPart();
        clubExamPart.id = data.id;
        clubExamPart.clubExamId = data.clubExamId;
        clubExamPart.description = data.description;
        clubExamPart.archived = data.archived;
        clubExamPart.isDeletable = data.isDeletable;

        return clubExamPart;
    }

    serialize() {
        return {
            id: this.id,
            clubExamId: this.clubExamId,
            description: this.description,
        }
    }
}
